import React, { useRef, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function PaymentForm({ onChange }) {
  const stripe = useStripe();
  const elements = useElements();
  const ref = useRef(null);

  useEffect(() => {
    ref.current = {
      createToken: async () => {
        const result = await stripe.createToken(
          elements.getElement(CardElement)
        );
        if (result.error) {
          throw new Error(result.error.message);
        } else {
          return result.token;
        }
      },
    };
  }, [stripe, elements]);

  const _onChange = (e) => {
    e.ref = ref.current;
    onChange(e);
  };

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  return (
    <div className="border border-gray-300 p-4 rounded">
      <CardElement id="card-element" options={cardStyle} onChange={_onChange} />
    </div>
  );
}
